import { boolean, object } from "valibot";
import { MAX_CHARACTERS_SM } from "../../constants";
import { requireText } from "./base";

export const baseDataSourceSchema = object({
  name: requireText(MAX_CHARACTERS_SM),
  availableOffline: boolean(),
});
